<div class="v2-pagina est-pagina">
    <div class="v2-inner">

        <div class="est-encabezado">
            <div class="est-icono"><i class="fas fa-chart-bar"></i></div>
            <div>
                <h1 class="est-titulo">Estadísticas</h1>
                <p class="est-subtitulo">{{temporada || 'Temporada actual'}} · Compilación a la jornada {{jornada || '—'}}</p>
            </div>
        </div>

        <div class="v2-tarjeta est-buscador" *ngIf="!equipoSel">
            <div class="est-input-envoltura">
                <i class="fas fa-search est-input-icono"></i>
                <input type="text" class="est-input" [placeholder]="Equipos.length === 0 ? 'Cargando equipos...' : 'Busca tu equipo por nombre...'" [disabled]="Equipos.length === 0" [(ngModel)]="busqueda" (input)="buscarEquipo()">
            </div>
            <p class="est-pista" *ngIf="!busqueda.trim()">Escribe el nombre de tu equipo para ver las estadísticas de bateo y pitcheo de todos sus jugadores.</p>
            <div class="est-resultados" *ngIf="busqueda.trim()">
                <p class="est-sin-resultados" *ngIf="resultados.length === 0">No se encontraron equipos con ese nombre.</p>
                <button type="button" class="est-resultado" *ngFor="let equipo of resultados" (click)="EquipoSeleccionado(equipo)">
                    <span class="est-resultado-inicial">{{equipo.Equipo.charAt(0)}}</span>
                    <span class="est-resultado-nombre">{{equipo.Equipo}}</span>
                </button>
            </div>
        </div>

        <div class="v2-tarjeta est-equipo-sel" *ngIf="equipoSel">
            <div class="est-equipo-info">
                <span class="est-equipo-inicial">{{(infoEquipo ? infoEquipo.nombre : equipoSel.Equipo).charAt(0)}}</span>
                <div class="est-equipo-textos">
                    <p class="est-equipo-nombre">{{infoEquipo ? infoEquipo.nombre : equipoSel.Equipo}}</p>
                    <p class="est-equipo-detalle" *ngIf="infoEquipo">{{infoEquipo.detalle}}</p>
                </div>
            </div>
            <button type="button" class="v2-boton-borde" (click)="cambiarEquipo()"><i class="fas fa-times"></i> Cambiar</button>
        </div>

        <ng-container *ngIf="equipoSel">
            <div class="est-tabs">
                <button type="button" class="est-tab" [class.activo]="tab === 'bateo'" (click)="tab = 'bateo'"><i class="fas fa-baseball-ball"></i> Bateo</button>
                <button type="button" class="est-tab" [class.activo]="tab === 'pitcheo'" (click)="tab = 'pitcheo'"><i class="fas fa-bullseye"></i> Pitcheo</button>
            </div>

            <div class="est-cargando" *ngIf="cargando"><i class="fas fa-spinner fa-spin"></i> Cargando estadísticas...</div>

            <ng-container *ngIf="!cargando && tab === 'bateo'">
                <div class="v2-tarjeta est-vacio" *ngIf="compilacionBateo.length === 0">
                    <i class="fas fa-baseball-ball"></i>
                    <p>Este equipo aún no tiene estadísticas de bateo registradas.</p>
                </div>
                <ng-container *ngIf="compilacionBateo.length > 0">
                    <div class="est-lideres">
                        <div class="v2-tarjeta est-lider" *ngFor="let lider of lideresBateo">
                            <div class="est-lider-fila">
                                <p class="est-lider-etiqueta">{{lider.etiqueta}}</p>
                                <i class="fas fa-award"></i>
                            </div>
                            <p class="est-lider-valor">{{lider.valor}}</p>
                            <p class="est-lider-jugador">{{lider.jugador}}</p>
                        </div>
                    </div>
                    <div class="v2-tarjeta est-tabla-tarjeta">
                        <div class="est-tabla-encabezado"><i class="fas fa-arrow-trend-up fa-chart-line"></i><span>Bateo · {{compilacionBateo.length}} jugadores</span></div>
                        <div class="est-tabla-envoltura">
                            <table class="est-tabla">
                                <thead>
                                    <tr>
                                        <th class="est-col-pos">#</th>
                                        <th class="est-col-jugador">Jugador</th>
                                        <th>JJ</th>
                                        <th>A</th>
                                        <th>VB</th>
                                        <th>H</th>
                                        <th>PCT</th>
                                        <th>C</th>
                                        <th>H2</th>
                                        <th>H3</th>
                                        <th>HR</th>
                                        <th>CP</th>
                                        <th>B</th>
                                        <th>R</th>
                                        <th>K</th>
                                        <th>DB</th>
                                        <th>SH</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr *ngFor="let bateo of compilacionBateo; let i = index" [class.est-fila-top]="i < 3">
                                        <td><span class="est-pos" [ngClass]="'est-pos-' + (i + 1)">{{i + 1}}</span></td>
                                        <td class="est-col-jugador">{{bateo.Jugador}}</td>
                                        <td>{{bateo.VJ}}</td>
                                        <td>{{bateo.V}}</td>
                                        <td>{{bateo.VB}}</td>
                                        <td class="est-negrita">{{bateo.TH}}</td>
                                        <td class="est-pct">{{bateo.PCT}}</td>
                                        <td>{{bateo.C}}</td>
                                        <td>{{bateo.H2}}</td>
                                        <td>{{bateo.H3}}</td>
                                        <td>{{bateo.HR}}</td>
                                        <td>{{bateo.CE}}</td>
                                        <td>{{bateo.B}}</td>
                                        <td>{{bateo.R}}</td>
                                        <td>{{bateo.K}}</td>
                                        <td>{{bateo.DB}}</td>
                                        <td>{{bateo.SH}}</td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                        <div class="est-leyenda">
                            <span><strong>JJ:</strong> Juegos jugados</span>
                            <span><strong>A:</strong> Apariciones</span>
                            <span><strong>VB:</strong> Veces al bat</span>
                            <span><strong>H:</strong> Hits</span>
                            <span><strong>PCT:</strong> Porcentaje</span>
                            <span><strong>C:</strong> Carreras</span>
                            <span><strong>H2:</strong> Dobles</span>
                            <span><strong>H3:</strong> Triples</span>
                            <span><strong>HR:</strong> Home runs</span>
                            <span><strong>CP:</strong> Carreras producidas</span>
                            <span><strong>B:</strong> Bases por bolas</span>
                            <span><strong>R:</strong> Robos</span>
                            <span><strong>K:</strong> Ponches</span>
                            <span><strong>DB:</strong> Dead ball</span>
                            <span><strong>SH:</strong> Sacrificios</span>
                        </div>
                    </div>
                </ng-container>
            </ng-container>

            <ng-container *ngIf="!cargando && tab === 'pitcheo'">
                <div class="v2-tarjeta est-vacio" *ngIf="compilacionPitcheo.length === 0">
                    <i class="fas fa-bullseye"></i>
                    <p>Este equipo aún no tiene estadísticas de pitcheo registradas.</p>
                </div>
                <ng-container *ngIf="compilacionPitcheo.length > 0">
                    <div class="est-lideres">
                        <div class="v2-tarjeta est-lider" *ngFor="let lider of lideresPitcheo">
                            <div class="est-lider-fila">
                                <p class="est-lider-etiqueta">{{lider.etiqueta}}</p>
                                <i class="fas fa-award"></i>
                            </div>
                            <p class="est-lider-valor">{{lider.valor}}</p>
                            <p class="est-lider-jugador">{{lider.jugador}}</p>
                        </div>
                    </div>
                    <div class="v2-tarjeta est-tabla-tarjeta">
                        <div class="est-tabla-encabezado"><i class="fas fa-chart-line"></i><span>Pitcheo · {{compilacionPitcheo.length}} jugadores</span></div>
                        <div class="est-tabla-envoltura">
                            <table class="est-tabla">
                                <thead>
                                    <tr>
                                        <th class="est-col-pos">#</th>
                                        <th class="est-col-jugador">Jugador</th>
                                        <th>JL</th>
                                        <th>G</th>
                                        <th>P</th>
                                        <th>PCT</th>
                                        <th>IP</th>
                                        <th>JE</th>
                                        <th>HA</th>
                                        <th>TC</th>
                                        <th>CL</th>
                                        <th>PCL</th>
                                        <th>BB</th>
                                        <th>K</th>
                                        <th>DB</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr *ngFor="let pitcheo of compilacionPitcheo; let i = index" [class.est-fila-top]="i < 3">
                                        <td><span class="est-pos" [ngClass]="'est-pos-' + (i + 1)">{{i + 1}}</span></td>
                                        <td class="est-col-jugador">{{pitcheo.Jugador}}</td>
                                        <td>{{pitcheo.Jugo}}</td>
                                        <td class="est-negrita">{{pitcheo.Ganados}}</td>
                                        <td>{{pitcheo.Perdidos}}</td>
                                        <td class="est-pct">{{pitcheo.PCT}}</td>
                                        <td>{{pitcheo.IP}}</td>
                                        <td>{{pitcheo.JE}}</td>
                                        <td>{{pitcheo.HA}}</td>
                                        <td>{{pitcheo.TC}}</td>
                                        <td>{{pitcheo.CL}}</td>
                                        <td>{{pitcheo.PCL}}</td>
                                        <td>{{pitcheo.BB}}</td>
                                        <td>{{pitcheo.K}}</td>
                                        <td>{{pitcheo.DB}}</td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                        <div class="est-leyenda">
                            <span><strong>JL:</strong> Juegos lanzados</span>
                            <span><strong>G:</strong> Ganados</span>
                            <span><strong>P:</strong> Perdidos</span>
                            <span><strong>PCT:</strong> Porcentaje</span>
                            <span><strong>IP:</strong> Innings lanzados</span>
                            <span><strong>HA:</strong> Hits admitidos</span>
                            <span><strong>TC:</strong> Total de carreras</span>
                            <span><strong>CL:</strong> Carreras limpias</span>
                            <span><strong>PCL:</strong> Promedio de carreras limpias</span>
                            <span><strong>BB:</strong> Bases por bolas</span>
                            <span><strong>K:</strong> Ponches</span>
                            <span><strong>DB:</strong> Dead ball</span>
                        </div>
                    </div>
                </ng-container>
            </ng-container>
        </ng-container>

    </div>
</div>
